module.exports = __webpack_public_path__ + "static/pic8-57b8355df91b7886010e61edf96a2f30.jpg";